import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../sch-test/delhi-prefit.module.css";
import TrustLogo from "../../assets/images/header/Trust-Logo.png";
import TrustIcon from "../../assets/images/header/Prajaahita.png"
import Setuwebpanner from "../../assets/images/upsc/Setu-Schorarship-Webbanner.jpg";
import Setumobpanner from "../../assets/images/upsc/Setu-Schorarship-Mpbile-banner.jpg";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { useState,useEffect } from 'react';
const pin = "../../assets/images/contact/pin.png";
const call = "../../assets/images/contact/call.png";
const mail = "../../assets/images/contact/mail.png";
import Form from "./scholarship-form";
//import Validationform from "../../components/validationform";
import {useRouter} from 'next/router';      
import Link from "next/link";
import NewiconA from "../../assets/images/header/modalnew.png";

const pwdScholarshipExam = () => {

     const contactcontent = [
    
    { heading: "Shankar IAS Academy - Head Office", Image: pin, address: (<><div> Door No 18, Old plot No 109, New plot No 259,</div> <div>AL Block, 4th Avenue, Shanthi Colony,</div> <div>Anna Nagar, Chennai-600 040.</div> </>), Image1: call, mobileno1: "9003190030", }, 
    { heading: "Adyar", Image: pin, address: (<> <div>No-2/23, 3rd Cross Street,</div> <div>Padmanabhanagar, Adyar,</div> <div> Chennai-600 020.</div> </>), Image1: call, mobileno: "90252 78278", },
    { heading: "Delhi", Image: pin, address: "No.25,2nd floor pusa road,karol Bagh", address1: "Delhi-110005.", Image1: call, mobileno: "88991 80180", },
    { heading: "Bengaluru", Image: pin, address: "No-34, 2nd stage, Basaveshwara HBCS layout, Chandra layout bus stand road, Bengaluru, Karnataka-560040.", address2: "Landmark : Opposite to Karur Vysya Bank", Image1: call, mobileno1: "81972 92121", },
    { heading: "Hyderabad ", Image: pin, address: "4th floor, Pasham Amrutha Ram Residency, Municipal No :1-2-234/13/46/4, Near bake zone bakery, Domalguda, Arvind nagar, Himayathnagar, Hyderabad, Telangana - 500029", Image1: call, mobileno: "83091 25825", },
    { heading: "Thiruvananthapuram", Image: pin, address: "2nd floor, Condor Plaza, TC 2/2421, Pattom Palace P.O., Thiruvananthapuram,", address1: "Kerala-695 004.", Image1: call, mobileno: "79949 36555", mobileno1: "75919 02600.", Image2: mail, mailid: "siatrivandrum@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/id9z1EDWhVfqJUVW9", url1: "https://goo.gl/maps/id9z1EDWhVfqJUVW9" },
    
    { heading: "Salem", Image: pin, address: "No.207/5 United Arcade, Kauveri Avenue, State Bank Colony, Junction Main Road, Salem-636 004.", Image1: call, mobileno: "0427-2441961", mobileno1: "89400 80039", Image2: mail, mailid: "salemsia@shankariasacad.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/NjfQjqauCjwEGjQaA", url1: "https://goo.gl/maps/NjfQjqauCjwEGjQaA" },
    { heading: "Madurai Admission Office", Image: pin, address: "Plot no:409/B, Mall super market, Second floor, church road, Anna Nagar, Sathamangalam, Madurai-625 020.", address2: "Landmark : Near Suguna stores bus stop, Second left towards Ambiga College", Image1: call, mobileno: "97896 22555", mobileno1: "0452-4255455", Image2: mail, mailid: "madurai@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/gtj5zwr9tg2saZU97", url1: "https://goo.gl/maps/gtj5zwr9tg2saZU97" },
    { heading: "Trichy", Image: pin, address: "N.R.Towers, A9 (N), Salai Road, Thillai Nagar, Trichy-620 018.", address2: "Landmark: LIC -Rock Fort Branch Building", Image1: call, mobileno: "0431-4976911", mobileno1: "97896 64555", Image2: mail, mailid: "trichy@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/bom1j7BjxF3pH4827", url1: "https://goo.gl/maps/bom1j7BjxF3pH4827" },
    { heading: "Namakkal", Image: pin, address: "Bank of Baroda Backside, Cheran Towers,Block No -2/67, 1st Floor ( West ) , Thillaipuram Main Road,Paramathi Rd,Namakkal-637 001.", Image1: call, mobileno: "99944 34921", mobileno1: "04286-223007", Image2: mail, mailid: "namakkalsia@shankariasacad.in", direction: "Get Directions", Image3: redrightarrow, url: "https://maps.app.goo.gl/GuxNaBunEbz5quTg6", url1: "https://goo.gl/maps/J2wbzRjw8N8akLtt7" },
    { heading: "Thiruvarur", Image: pin, address: "No 91, ONS Complex, Nethaji Road, Thiruvarur-610 001.", Image1: call, mobileno: "04366 222972", mobileno1: "97877 34943", Image2: mail, mailid: "thiruvarur@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/xKQJnCJf5UgcxWVi7", url1: "https://goo.gl/maps/xKQJnCJf5UgcxWVi7" },
  
  
    
  ]

  return (
        <>
            <Head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title> UPSC SETU Scholarship Test 2025 </title>
                <meta name="title" content="Inclusive UPSC Coaching for Persons with Disabilities | SETU by Shankar IAS Academy" />
                <meta name="description" content="Apply now for SETU, an inclusive UPSC coaching program for Persons with Disabilities. Get fully funded coaching, accessible learning, and mentorship. Limited seats available." />
				        <meta name="keywords" content="inclusive UPSC coaching, UPSC coaching for persons with disabilities, IAS coaching PwD, SETU scholarship UPSC, accessible IAS classes, Shankar IAS for disabled aspirants" />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-setu-scholarship-test/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Inclusive UPSC Coaching for Persons with Disabilities | SETU by Shankar IAS Academy" />
                <meta property="og:description" content="Apply now for SETU, an inclusive UPSC coaching program for Persons with Disabilities. Get fully funded coaching, accessible learning, and mentorship. Limited seats available." />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-setu-scholarship-test/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

            <Navbar title="sch-test"/>

            <div className="container">
                <div className="row">
                    <div className="col pt-3 pt-md-2">
                        <h1 className={`${styles.pagemaintitle}`}>
                        UPSC SETU Scholarship Test 2025
                        </h1>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row d-none d-md-block">
                   <div className="col pt-2 mb-3">
                        <Image
                          src={Setuwebpanner}
                          alt="UPSC SETU Scholarship Test 2025"
                          title="UPSC SETU Scholarship Test 2025"
                          className="img-fluid w-100"
                        />
                    </div>
                </div>
            
                <div className="row d-block d-md-none">
                    <div className="col mb-3">
                          <Image
                            src={Setumobpanner}
                           alt="UPSC SETU Scholarship Test 2025"
                           title="UPSC SETU Scholarship Test 2025"
                           className="img-fluid w-100"
                          />
                    </div>
                </div>
            </div>
  <div className="" id="gspcm" >
    <Form /> 
 </div>
      
<div className="container py-5">
<div className="row g-4">
  <div className="col-md-3 text-center mb-5 d-none d-md-block">
      <Image
        src={TrustIcon}
        alt="New Icon"
        title="New Icon"
        className="img-fluid"
        width={180}
        height={180}
      />
    </div>
  <div className="col-md-6 text-center mb-5">
    <h2 className={`${styles.pagemaintitle1} fw-bold text-uppercase`}>
      SETU – Inclusive UPSC Coaching Program for Persons with Disabilities
    </h2>
    <p className="">
     Powered by  <span className="text-danger"> Shankar IAS Academy</span> &{" "}
      <span className="">Prajaahita Foundation</span>
    </p>
  </div>

    <div className="col-md-3 text-center mb-5 d-none d-md-block">
      <Image
        src={TrustLogo}
        alt="New Icon"
        title="New Icon"
        className="img-fluid"
      />
    </div>

  </div>
  <div className="row g-4">

   <div className="col-md-6">
  <div
    className="p-4 rounded-4 h-100"
    style={{
      background:
        "linear-gradient(to top, #fff2f2, #fff2f2)",
      opacity: 1,
    }}
  >
    <h4 className="fw-bold mb-3 pt-3">Why SETU Matters</h4> 
    <p className={`${styles.acheiverrank}pt-2`} style={{ fontSize: "18px" }}>Talent is everywhere. Opportunity is limited.</p>
    <p className={`${styles.acheiverrank}pt-2`} style={{ fontSize: "18px" }}>
      Every year, thousands of persons with disabilities aspire to serve the nation through the civil services. But systemic barriers, not lack of ability, stand in their way.
    </p>
    <p className={`${styles.acheiverrank}pt-2`} style={{ fontSize: "18px" }}>
      SETU (Support in Education and Training for UPSC Examination) changes that. This is a pioneering inclusive UPSC coaching initiative, designed specifically to provide equitable access, personalised support, and preparation for aspirants with disabilities.
    </p>
    <p className={`${styles.acheiverrank}pt-2`}style={{ fontSize: "18px" }}>
      A partnership between Shankar IAS Academy, Shankar Memorial Educational & Charitable Trust, and the Prajaahita Foundation, SETU is a structured bridge between ambition and achievement.
    </p>
  </div>
</div>



    <div className="col-md-6">
      <div className="p-4 rounded-4  h-100"  style={{
      background:
        "linear-gradient(to top, #fff2f2, #fff2f2)",
      opacity: 1,
    }}>
        <h4 className={`${styles.pagemaintitle} fw-bold`} style={{ color: "#1b1818ff" }}> What You Get with SETU</h4>
          <p className={`${styles.acheiverrank}`}style={{ fontSize: "18px" }}>
             SETU is not just coaching. It is an ecosystem built for accessibility, equity, and success.
          </p>
          <ul className="list-unstyled pt-2 mb-0">
          <li className={`${styles.acheiverrank}mb-2`} style={{ fontSize: "18px" }}>✔ Fully Funded Scholarships
              30 scholarships in 2025, scaling to 400+ nationwide by 2029
              Covers complete UPSC preparation at Shankar IAS Academy
          </li>
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Accessible Learning Formats
              Braille, large print, screen reader compatible material
              Audio lectures and visual aids tailored for all learning needs
          </li>

          <li  className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Reasonable Exam Accommodations
              Extended exam time, scribes, sign language interpreters
              Accessible mock tests designed for UPSC pattern
          </li>

          <li  className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Hybrid Coaching Model
            Learn in person at Shankar IAS centres or online from home
            Same expert faculty, same proven results
          </li>
          <li  className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Mentorship and Inclusion Support
            Dedicated mentors from the civil services and alumni network
            Peer learning and guidance led by Prajaahita Foundation
          </li>

         
        </ul>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-4 rounded-4   h-100"  style={{
      background:
        "linear-gradient(to top, #fff2f2, #fff2f2)",
      opacity: 1,
    }}>
        <h4 className="fw-bold mb-3"> Who Should Apply</h4>
        <ul className="list-unstyled pt-2 mb-0">
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Persons with disability (PwD) as defined under the RPwD Act, 2016</li>
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Age: Minimum 21 years. Maximum age limits (including PwD relaxations) are as follows:</li>
           <ul className=" pt-2 mb-0">
            <li className='mb-2'>PwD (General/EWS): 42 years</li>
            <li className='mb-2'>PwD + OBC: 45 years</li>
            <li className='mb-2'>PwD + SC/ST: 47 years</li>
           </ul>
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔ Graduates or final year students preparing for the UPSC Civil Services Examination.</li>
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>✔  Aspirants determined to serve the nation and break barriers that hold others back</li>
        </ul>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-4 rounded-4   h-100"  style={{
      background:
       "linear-gradient(to top, #fff2f2, #fff2f2)",
      opacity: 1,
    }}>
        <h4 className="fw-bold mb-3">Why SETU Is Different</h4>
         <p className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}> SETU has been thoughtfully designed from inception to prioritize accessibility and inclusion, rather than adapting support as an afterthought.</p>
        <ul className=" mb-0">
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}> Anchored by Shankar IAS Academy, a trusted name in UPSC coaching for over 20 years</li>
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>Inclusion support driven by Prajaahita Foundation, specialists in disability advocacy and education</li>
          <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}> Fully aligned with RPwD Act, 2016 and UNCRPD principles</li>
        </ul>

        {/* <div className="p-3 my-4 text-center border-start border-4 border-primary bg-light rounded-3 shadow-sm">
  <p className="fst-italic mb-2">
    "This is one of the most significant initiatives in Shankar IAS Academy’s journey. SETU opens the door for every deserving aspirant and we are proud to stand behind it”
  </p>
  <p className="fw-semibold mb-0">
    — (Name of senior professional, ex IAS officer etc.)
  </p>
  <small className="text-muted">Shankar IAS Academy</small>
</div> */}
      </div>
    </div>

    

  </div>
</div>


<div className="container py-5">

  <div className="mb-5">
    <h3 className="fw-bold text-center mb-4 ">
      Application Process
    </h3>

    <div className="row justify-content-center">
      <div className="col-md-8">
        <ul className="list-group list-group-flush shadow-sm border rounded-3">
          <li className="list-group-item py-3">
            <span className="fw-bold text-primary">1.</span> Fill out the SETU Scholarship Application Form
          </li>
          <li className="list-group-item py-3">
            <span className="fw-bold text-primary">2.</span> Select your preferred Shankar IAS Academy centre or online mode
          </li>
          <li className="list-group-item py-3">
            <span className="fw-bold text-primary">3.</span> Specify any required accommodations (scribe, interpreter, assistive device)
          </li>
          <li className="list-group-item py-3">
            <span className="fw-bold text-primary">4.</span> Appear for the scholarship test at your designated centre or online
          </li>
          <li className="list-group-item py-3">
            <span className="fw-bold text-primary">5.</span> Await selection and orientation details
          </li>
          <div className="text-center p-2">
            <a href="/upsc-setu-scholarship-test/#gspcm" className="btn btn-primary px-4 py-2 rounded-pill shadow-sm">
              Apply Now
            </a>
        </div>
        </ul>
        
      </div>
    </div>
  </div>

  <div className="row justify-content-center mt-5">
  <div className="col-md-8">
    <h4 className="fw-bold text-center mb-4"> Application Timeline</h4>

    <ul className="list-group list-group-flush shadow-sm border rounded-3">
      <li className="list-group-item py-3 text-center">
        <span className="fw-bold ">1.</span> Application Deadline: <strong>September 18, 2025</strong>
      </li>
      <li className="list-group-item py-3 text-center">
        <span className="fw-bold ">2.</span> Scholarship Test: <strong>September 21 , 2025</strong>
      </li>
      <li className="list-group-item py-3 text-center">
        <span className="fw-bold ">3.</span> Mode: <strong>In person</strong> at selected Shankar IAS centres across India or <strong>Online</strong>
      </li>
      <li className="list-group-item py-3 text-center">
        <span className="fw-bold">4.</span> Next Steps: <strong>for Shortlisted Candidates Interview and Orientation</strong>
      </li>
    </ul>
  </div>
</div>

 <div className="mt-5">
  <h4 className="fw-bold text-center mb-4">
    SETU is supported by:
  </h4>

  <div className="row g-4">
    <div className="col-md-6">
      <div className="card h-100 shadow-lg border-0 rounded-4 bg-light">
        <div className="card-body pt-4 mt-2">
          <div className="d-flex align-items-center mb-3">
            <div className=" text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "120px", height: "10px", fontSize: "28px" }}>
               <Image
                src={TrustLogo}
                alt="New Icon"
                title="New Icon"
                className="img-fluid"
              />
            </div>
            <h5 className="fw-bold mb-0 text-danger" style={{ color: "#d61616ff" }}>
              Shankar Memorial Educational & Charitable Trust
            </h5>
          </div>
          <p className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>
            Carrying forward the enduring vision and values of<strong> Mr. Shankar,</strong> a pioneer in UPSC education and founder of Shankar IAS Academy.  
          </p>
        </div>
      </div>
    </div>


    <div className="col-md-6">
      <div className="card h-100 shadow-lg border-0 rounded-4 bg-light">
        <div className="card-body ">
          <div className="d-flex align-items-center mb-3">
            <div className=" text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "60px", height: "60px", fontSize: "28px" }}>
              <Image
                src={TrustIcon}
                alt="New Icon"
                title="New Icon"
                className="img-fluid"
              />
            </div>
            <h5 className="fw-bold mb-0 text-dark">
              Prajaahita Foundation – Inclusion Partner
            </h5>
          </div>
          <p className={`${styles.acheiverrank}mb-2 `} style={{ fontSize: "18px"}}>
            Led by <strong>Sooraj Santhosh Kumar</strong>, a former UPSC aspirant and social entrepreneur, Prajaahita builds sustainable education and employment pathways for persons with disabilities across India.  
          </p>
        </div>
      </div>
    </div>
     <p className="fw-bold fs-5 mb-0 text-center mt-4">
      Together, we are committed to building an inclusive future for India’s civil services. </p>

  </div>

  
<div className="text-center mt-5 px-3">
  <div
    className="p-4 rounded-4 "
   style={{
      background:
        "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgba(182, 238, 255, 0.29))",
      opacity: 1,
    }}
  >
    <p className="fw-bold fs-5 mb-0">
      Know Someone Who Needs This?
      <br />
      
    </p>
    <p><span className="  d-block mt-2">
       If you know someone who dreams of joining the civil services but faces barriers, please share SETU with them. Together, we can open the door to new possibilities.
      </span></p>
  </div>
</div>
</div>
</div>






<section className="pt-md-3 pt-lg-4" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
      <div className="container pt-3">
          <div className={`${styles.head}  pt-2 pb-2`}>
                   <h3> Test - Venue</h3>
          </div>
          <div className="row">
                <div className="col">
                  <div className="row">
                    {contactcontent.map((item, index) => (
                      <div className="col-md-6 col-lg-4 col-12 mb-3" key={index}>
                        <div className={`${styles.contactbox} h-100`}>
                          <div className={`${styles.contactboxheight} px-4 pt-4  pt-md-5`}>


                            <div className={`${styles.acheivername} mb-3`} style={{color:"#db1b0d"}}>{item.heading}</div>

                            <div className="row">
                              <div className="col-1 pe-0">
                                <Image src={item.Image} className="img-fluid" width={14} height={14} alt="location" title="Branch Address" />
                              </div>
                              <div className="col-11 ">
                                <div className={`${styles.acheiverrank} mb-0`}>{item.address}</div>
                                <div className={`${styles.acheiverrank} mb-0`}>{item.address1}</div>
                                <div className={`${styles.contactsubcontent}`}>{item.address2}</div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-1 pe-0">
                                <Image src={item.Image1} className="img-fluid" width={14} height={14} alt="number icon" title="Branch Contact Number" />
                              </div>
                              <div className="col-11 ">
                                <p className={`${styles.acheiverrank} mb-0`}>{item.annanager}<a href="tel:044-66024500" className={`${styles.mobilemaillinks}`}>{item.mobileno}</a></p>
                                <p className={`${styles.acheiverrank}`}>{item.adyar}<a href="tel:76677 66266" className={`${styles.mobilemaillinks}`}>{item.mobileno1}</a></p>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
          </div>
      </div>
</section>

            <Footer />


        </>
    )
}

export default pwdScholarshipExam;